<ng-container *ngIf="processingType === 'CODE'">
  <ng-container *ngIf="!isVerificationSuccessful">
    <h1>{{ "VERIFICATION_COMPLETE.PROMPT_ENTER" | translate }}</h1>
    <app-input-group [options]="inputGroupOption" (btnEvent)="submit()" (inputEvent)="updateVerificationCode($event)" [inputLoading]="updateInProgress">
    </app-input-group>
    <div class="mat-error">
      {{ errorMessage | translate }}
    </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="processingType === 'LINK'">
  <ng-container *ngIf="!isVerificationSuccessful && !usage_type">
    <h1> {{ "VERIFICATION_COMPLETE.PROMPT_ENTER_LINK" | translate :{client_display_name:client_display_name} }}</h1>
    <div class="mat-error">
      {{ errorMessage | translate }}
    </div>
  </ng-container>
  <ng-container *ngIf="usage_type">
    {{ "VERIFICATION_COMPLETE.SUCCESS_MSG_EMAIL" | translate }}
  </ng-container>

</ng-container>


<ng-container *ngIf="isVerificationSuccessful">
  <h1 *ngIf="type === 'email'">
    {{ "VERIFICATION_COMPLETE.SUCCESS_MSG_EMAIL" | translate }}
  </h1>
  <h1 *ngIf="type !== 'email'">
    {{ "VERIFICATION_COMPLETE.SUCCESS_MSG_MOBILE" | translate }}
  </h1>
  <div *cidPageLoader="pageLoading"></div>
  <app-button (clickEvent)="commonFunc.getRedirectedByRequestId()" [btnOption]="buttonOptions.backToLogin">
  </app-button>
</ng-container>

